// ── Step Card (unified, arm or service) ───────────────────────────────────────
const StepCard = ({ step, index, total, onDelete, onMoveUp, onMoveDown }) => {
  const isRobot = step.is_physical;

  const armSummary = () => {
    if (!isRobot) return null;
    const jv = step.joint_values;
    const parts = [];
    if (jv.base !== undefined)     parts.push(`Base ${jv.base}°`);
    if (jv.shoulder !== undefined) parts.push(`Shoulder ${jv.shoulder}°`);
    if (jv.elbow !== undefined)    parts.push(`Elbow ${jv.elbow}°`);
    if (jv.gripper !== undefined)  parts.push(`Gripper ${jv.gripper}°`);
    return parts.join(" · ");
  };

  const propBadge = (label, color) => (
    <span style={{
      fontSize: 9, fontWeight: 700, padding: "2px 6px",
      borderRadius: 4, background: `${color}18`, color, border: `1px solid ${color}44`,
      letterSpacing: 0.3,
    }}>{label}</span>
  );

  return (
    <div style={{
      border: `1px solid ${isRobot ? "#bfdbfe" : "#bbf7d0"}`,
      borderRadius: 8,
      padding: "8px 10px",
      background: isRobot ? "#f0f7ff" : "#f0fdf4",
      display: "flex",
      alignItems: "center",
      gap: 8,
    }}>
      {/* Step number */}
      <div style={{
        width: 22, height: 22, borderRadius: "50%", flexShrink: 0,
        background: isRobot ? "#3B82F6" : "#16a34a",
        color: "white", fontSize: 10, fontWeight: 700,
        display: "flex", alignItems: "center", justifyContent: "center",
      }}>{index + 1}</div>

      {/* Type badge */}
      <div style={{
        fontSize: 9, fontWeight: 700, padding: "3px 7px", borderRadius: 5, flexShrink: 0,
        background: isRobot ? "#3B82F6" : "#16a34a",
        color: "white", letterSpacing: 0.5,
      }}>{isRobot ? "ARM" : "SERVICE"}</div>

      {/* Content */}
      <div style={{ flex: 1, minWidth: 0 }}>
        {isRobot ? (
          <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
            <span style={{ fontSize: 11, color: "#1e3a5f", fontWeight: 500, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
              {armSummary()}
            </span>
            {step.interval !== undefined && (
              <span style={{ fontSize: 10, color: "#6b7280", background: "#e5e7eb", borderRadius: 4, padding: "1px 6px", flexShrink: 0 }}>
                {step.interval}ms
              </span>
            )}
          </div>
        ) : (
          <div style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
            <span style={{ fontSize: 11, color: "#14532d", fontWeight: 500 }}>
              {step.service?.char_desc || "Service Step"}
            </span>
            <div style={{ display: "flex", gap: 3 }}>
              {step.service?.can_read   && propBadge("R", "#3B82F6")}
              {step.service?.can_write  && propBadge("W", "#10B981")}
              {step.service?.can_notify && propBadge("N", "#F59E0B")}
            </div>
          </div>
        )}
      </div>

      {/* Controls */}
      <div style={{ display: "flex", gap: 3, flexShrink: 0 }}>
        <button
          onClick={onMoveUp} disabled={index === 0}
          style={{ width: 24, height: 24, border: "1px solid #e2e8f0", borderRadius: 5, background: "white", cursor: index === 0 ? "default" : "pointer", color: index === 0 ? "#d1d5db" : "#6b7280", fontSize: 11, display: "flex", alignItems: "center", justifyContent: "center" }}>↑</button>
        <button
          onClick={onMoveDown} disabled={index === total - 1}
          style={{ width: 24, height: 24, border: "1px solid #e2e8f0", borderRadius: 5, background: "white", cursor: index === total - 1 ? "default" : "pointer", color: index === total - 1 ? "#d1d5db" : "#6b7280", fontSize: 11, display: "flex", alignItems: "center", justifyContent: "center" }}>↓</button>
        <button
          onClick={onDelete}
          style={{ width: 24, height: 24, border: "1px solid #fecaca", borderRadius: 5, background: "#fff5f5", cursor: "pointer", color: "#ef4444", fontSize: 13, display: "flex", alignItems: "center", justifyContent: "center" }}>×</button>
      </div>
    </div>
  );
};

export default StepCard